import { useEffect, useState } from "react";
import { Target } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { periodLabel } from "./BranchTargetPopup";

export function BranchTargetCard() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/branch-requests/target").then((r) => setCfg(r.data)).catch(() => setCfg({ enabled: false, target: 5, period: "2026-11", message: "" })); }, []);
  const save = async (patch) => {
    const next = { ...cfg, ...patch };
    setSaving(true);
    try {
      await api.put("/branch-requests/target", { enabled: next.enabled, target: Number(next.target) || 5, period: next.period, message: next.message || "" });
      setCfg(next); toast.success(next.enabled ? "Target Buka Cabang Baru AKTIF — pop up tampil ke agen" : "Target Buka Cabang Baru dinonaktifkan");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  if (!cfg) return null;
  return (
    <Card className="bg-card border-border" data-testid="branch-target-settings">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-heading flex items-center justify-between gap-2">
          <span className="flex items-center gap-2"><Target className="w-4 h-4 text-[#F04E23]" /> Target Buka Cabang Baru</span>
          <span className={`text-[11px] font-mono px-2 py-0.5 rounded-full border ${cfg.enabled ? "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" : "bg-muted text-muted-foreground border-border"}`} data-testid="branch-target-status">{cfg.enabled ? "AKTIF" : "NONAKTIF"}</span>
        </CardTitle>
        <p className="text-xs text-muted-foreground">Pop up ke agen yang diizinkan Buka Cabang Baru: "Anda memiliki target membuka {cfg.target} cabang baru pada bulan {periodLabel(cfg.period)}". Tercapai periode ini: <b className="text-foreground">{cfg.achieved ?? 0}</b> cabang disetujui.</p>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-2 gap-2">
          <div className="space-y-1.5"><Label>Jumlah target</Label><Input type="number" min="1" max="100" value={cfg.target} onChange={(e) => setCfg({ ...cfg, target: e.target.value })} data-testid="branch-target-input" /></div>
          <div className="space-y-1.5"><Label>Bulan</Label><Input type="month" value={cfg.period} onChange={(e) => setCfg({ ...cfg, period: e.target.value })} data-testid="branch-target-period" /></div>
        </div>
        <div className="space-y-1.5"><Label>Pesan tambahan (opsional)</Label><Input value={cfg.message || ""} onChange={(e) => setCfg({ ...cfg, message: e.target.value })} placeholder="Pesan penyemangat untuk agen (opsional)" data-testid="branch-target-message-input" /></div>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="outline" disabled={saving} onClick={() => save({})} data-testid="branch-target-save">Simpan</Button>
          <Button disabled={saving} onClick={() => save({ enabled: !cfg.enabled })} className={cfg.enabled ? "bg-rose-600 hover:bg-rose-700 text-white" : "bg-emerald-600 hover:bg-emerald-700 text-white"} data-testid="branch-target-toggle">{cfg.enabled ? "Nonaktifkan Program" : "Aktifkan Program"}</Button>
        </div>
      </CardContent>
    </Card>
  );
}
